import { FormLabel, Select, SelectProps, forwardRef } from '@chakra-ui/react';
import { WithFormControl } from '../WithFormControl';
import { t } from '@/i18n';

export const PageSizeSelector = forwardRef<SelectProps, 'select'>((props, ref) => {
  return (
    <WithFormControl width='auto' flexDir='row' display='flex' alignItems='end'>
      <FormLabel color='text.main' whiteSpace='nowrap' fontSize='sm'>
        {t('components.list_pagination_control.list_pagination_control_formlabel')},
      </FormLabel>
      <Select variant='' size='sm' {...props} ref={ref}>
        <option value='10'>10</option>
        <option value='25'>25</option>
        <option value='100'>100</option>
      </Select>
    </WithFormControl>
  );
});
